import { Extension } from '@tiptap/core';
import { createProtectedNodePlugin, type ProtectedNodeDeletePromptContext } from './protected-node-plugin';

export {
    createProtectedNodePlugin,
    getProtectedNodesDeletedInTransaction,
    getReferencedNodesDeletedInTransaction,
    PROTECTED_NODE_BYPASS_META_KEY,
    protectedNodePluginKey,
} from './protected-node-plugin';
export type { ProtectedNodeDeletePromptContext, ProtectedNodeDeletionInfo, ReferencedResourceDeletionInfo } from './protected-node-plugin';

export interface ProtectedNodeOptions {
    protectedNodeTypes: string[];
    onProtectedDeletePrompt: (ctx: ProtectedNodeDeletePromptContext) => void;
}

export const ProtectedNode = Extension.create<ProtectedNodeOptions>({
    name: 'protectedNode',

    addOptions() {
        return {
            protectedNodeTypes: [
                'zyBlock',
                'zyCode',
                'zyExercise',
                'zyExample',
                'zyAside',
                'zyAnimator',
                'zyCommonError',
                'zyConsole',
                'zyDE',
                'zyExplore',
                'zyFootnote',
                'zyTool',
                'zyMathWorksLearningTool',
                'zyYoutubeVideo',
                'zyStudio',
                'zyClassicLab',
                'zyITLab',
                'zyImage',
                'zyInlineEnum',
                'zyIframe',
                'questionSet',
                'progressionBuilder',
                'blockOrderingBuilder',
                'codeWritingBuilder',
                'codeOutputBuilder',
                'parsonsCodingBuilder',
                'streamlitApp',
            ],

            /** Headless / import paths: allow deletes without UI. */
            onProtectedDeletePrompt: ({ resolve }: ProtectedNodeDeletePromptContext) => {
                queueMicrotask(() => resolve(true));
            },
        };
    },

    addProseMirrorPlugins() {
        return [
            createProtectedNodePlugin({
                protectedNodeTypes: this.options.protectedNodeTypes,
                getEditor: () => this.editor,
                onProtectedDeletePrompt: this.options.onProtectedDeletePrompt,
            }),
        ];
    },
});

export default ProtectedNode;
